<template>
	<!-- banner -->
	<section v-if="topoBanner != ''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoBanner[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoBanner[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->
	<div class="ftco-section contact-section ftco-no-pb">
		<!-- container -->
		<div class="container">
			<!-- row -->
			<div class="row">
				<div class="col-md-6">
					<!-- Billing Details -->
					<div class="billing-details">
						<div class="section-title">
							<h3 class="title">Dados Empresa e Entrega</h3>
						</div>
						<div class="row" style="padding-bottom: 10px;">
							<form action="#" class="bg-light p-4 p-md-5 contact-form">
								<div class="row">
									<div class="col-md-6">
										<div class="form-group">
											<input v-model="nome" type="text" class="form-control" placeholder="Nome">
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group">
											<input v-model="email" type="text" class="form-control" placeholder="Email">
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group">
											<input v-model="telefone" v-mask="'(##) #####-####'" type="text"
												class="form-control" placeholder="Telefone">
										</div>
									</div>
									<div class="col-md-6">
										<div class="form-group">
											<input v-model="numCep" v-mask="'#####-###'" type="text"
												class="form-control" placeholder="CEP">
										</div>
									</div>
									<div class="col-md-12">
										<div class="form-group">
											<button class="btn btn-primary py-3 px-5"
												@click.prevent="Buscacep(numCep)">Verificar</button>
										</div>
									</div>
									<div class="col-md-12" v-if="showend">
										<div class="form-group">
											<input v-model="endereco" type="text" class="form-control"
												placeholder="Endereço">
										</div>
									</div>
									<div class="col-md-4" v-if="showend">
										<div class="form-group">
											<input v-model="numeroend" type="text" class="form-control"
												placeholder="Número">
										</div>
									</div>
									<div class="col-md-8" v-if="showend">
										<div class="form-group">
											<input v-model="complemento" type="text" class="form-control"
												placeholder="Complemento">
										</div>
									</div>
									<div class="col-md-5" v-if="showend">
										<div class="form-group">
											<input v-model="nomeCidade" type="text" class="form-control"
												placeholder="Cidade">
										</div>
									</div>
									<div class="col-md-3" v-if="showend">
										<div class="form-group">
											<input v-model="siglaEstado" type="text" class="form-control"
												placeholder="UF">
										</div>
									</div>
									<div class="col-md-4" v-if="showend">
										<div class="form-group">
											<input v-model="nomeBairro" type="text" class="form-control"
												placeholder="Bairro">
										</div>
									</div>
									<div class="col-md-12" v-if="showend">
										<h3 class="title">Observações sobre Orçamento</h3>
										<div class="form-group">
											<textarea rows="6" v-model="Observacoes" type="text" class="form-control"
												placeholder="Observações"></textarea>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>

				<!-- Order Details -->
				<div class="col-md-6 order-details bt-80">
					<div class="section-title text-center">
						<h3 class="title">Itens do Orçamento</h3>
					</div>
					<div class="order-summary">
						<div class="order-col">
							<div style="width: 20%;"><strong>Img</strong></div>
							<div style="width: 50%;"><strong>Produto</strong></div>
							<div style="width: 20%;"><strong>Qtde</strong></div>
							<div style="width: 20%;"><strong>Excluir</strong></div>
						</div>
						<div class="order-products" v-for="(itemp, index) in DadosCompra.produtos" :key="index">
							<div class="order-col">
								<div style="width: 20%;">
									<img class="img-cart img-fluid"
										style="border:1px solid #cccccc;width:100%;height: auto;"
										:src="$imgURL + itemp.insInstitucionalImagens[0].itgUrlImagem">
								</div>
								<div style="width: 40%;font-size: 14px;">{{ itemp.itiNome }}</div>
								<div style="width: 40%;text-align: center;">{{ itemp.proQtde }}</div>
								<div style="width: 20%;text-align: center;">
									<a data-toggle="tooltip" data-placement="top" @click="ExcluiProduto(index)"
										title="Excluir">
										<i class="fa fa-window-close"></i>
									</a>
								</div>
							</div>
						</div>
					</div>
					<a href="#" @click.prevent="carregaDados()" class="btn btn-primary py-3 px-5">Enviar Orçamento</a>
				</div>
				<!-- /Order Details -->
			</div>
			<!-- /row -->
		</div>
		<!-- /container -->
	</div>


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'


export default {
	name: 'CarrinhoView',
	components: {

	},
	data: () => ({
		topoBanner: [],
		carrinho: [],
		DadosCompra: {
			produtos: [],
			mensagem: [],
			agenda: [],
			foto: [],
			avulsos: [],
			baloes: [],
			informacao: [],
			pagamento: [],
			cupom: [],
		},
		nome: '',
		cnpj: '',
		responsavel: '',
		telefone: '',
		email: '',
		endereco: '',
		numeroend: '',
		complemento: '',
		siglaEstado: '',
		nomeCidade: '',
		nomeBairro: '',
		numCep: '',
		Observacoes: '',
		Retornocep: {},
		showend: false,
		contato: [],
	}),

	methods: {
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},
		Buscacep(value) {
			fetch("https://viacep.com.br/ws/" + value + "/json/")
				.then(response => {
					if (!response.ok) {
						throw new Error("CEP inexistente");
					}
					return response.json();
				})
				.then(data => {
					this.Retornocep = data;
					if (this.Retornocep != null) {
						this.endereco = this.Retornocep.logradouro;
						this.numeroend = null;
						this.complemento = null;
						this.siglaEstado = this.Retornocep.uf;
						this.nomeCidade = this.Retornocep.localidade;
						this.nomeBairro = this.Retornocep.bairro;
						this.showend = true;
					} else {
						alert("CEP inexistente");
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		ExcluiProduto(index) {
			let dadosArmazenados = localStorage.getItem(this.$DadosCompra);

			if (dadosArmazenados) {
				dadosArmazenados = JSON.parse(dadosArmazenados);
				dadosArmazenados.produtos.splice(index, 1);

				if (dadosArmazenados.produtos.length == 0) {
					localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados));
					this.$router.go(0);
					this.$mensagemAviso("Carrinho vazio, escolha produtos e adicione no carrinho.")
				}
				else {
					localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados));
					this.$store.commit('updateVariavelHeader2', dadosArmazenados.produtos.length);
					this.DadosCompra.produtos = [...dadosArmazenados.produtos];
				}
			}
		},
		carregaMetas(texto) {
			useHead({
				title: 'Carrinho - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
		carregaDados() {
			if (this.numCep == '') {
				this.$mensagemAviso("Preencha o CEP de entrega e clique em verificar.");
			} else if (this.nome == '') {
				this.$mensagemAviso("Preencha o campo nome");
			} else if (this.telefone == '') {
				this.$mensagemAviso("Preencha o telefone");
			} else if (this.email == '') {
				this.$mensagemAviso("Preencha o e-mail");
			} else if (this.endereco == '') {
				this.$mensagemAviso("Preencha o endereço de entrega");
			} else if (this.numeroend == null) {
				this.$mensagemAviso("Preencha o número do endereço de entrega");
			} else if (this.complemento == '') {
				this.$mensagemAviso("Preencha o complemento do endereço de entrega");
			} else if (this.nomeCidade == '') {
				this.$mensagemAviso("Preencha a cidade do endereço de entrega");
			} else if (this.siglaEstado == '') {
				this.$mensagemAviso("Preencha a sigla do estado do endereço de entrega");
			} else if (this.nomeBairro == '') {
				this.$mensagemAviso("Preencha o bairro do endereço de entrega");
			}
			else {
				let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
				if (dadosArmazenados) {
					dadosArmazenados = JSON.parse(dadosArmazenados);
					if (dadosArmazenados.agenda[0] != null) {
						dadosArmazenados.agenda[0] = {
							nome: this.nome,
							telefone: this.telefone,
							email: this.email,
							cnpj: this.cnpj,
							responsavel: this.responsavel,
							estado: this.siglaEstado,
							cidade: this.nomeCidade,
							bairro: this.nomeBairro,
							endereco: this.endereco,
							numero: this.numeroend,
							complemento: this.complemento,
							cep: this.numCep,
							Obs: this.Observacoes
						};
					}
					else {
						dadosArmazenados.agenda.push({
							nome: this.nome,
							telefone: this.telefone,
							email: this.email,
							cnpj: this.cnpj,
							responsavel: this.responsavel,
							estado: this.siglaEstado,
							cidade: this.nomeCidade,
							bairro: this.nomeBairro,
							endereco: this.endereco,
							numero: this.numeroend,
							complemento: this.complemento,
							cep: this.numCep,
							Obs: this.Observacoes
						});
					}
				}
				localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados))
				this.EnviaEmail();

			}
		},
		EnviaEmail() {
			//console.log('aqui')
			let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
			dadosArmazenados = JSON.parse(dadosArmazenados);

			var dadosPedido = "<strong>Dados Cadastro</strong> <br><br>";
			dadosPedido += "Nome: " + dadosArmazenados.agenda[0].nome + "<br>";
			dadosPedido += "Telefone: " + dadosArmazenados.agenda[0].telefone + "<br>";
			dadosPedido += "E-mail: " + dadosArmazenados.agenda[0].email + "<br>";
			dadosPedido += "Endereço: " + dadosArmazenados.agenda[0].endereco + "<br>";
			dadosPedido += "Numero: " + dadosArmazenados.agenda[0].numero + "<br>";
			dadosPedido += "Complemento: " + dadosArmazenados.agenda[0].complemento + "<br>";
			dadosPedido += "CEP: " + dadosArmazenados.agenda[0].cep + "<br>";
			dadosPedido += "Cidade: " + dadosArmazenados.agenda[0].cidade + "<br>";
			dadosPedido += "Bairro: " + dadosArmazenados.agenda[0].bairro + "<br>";
			dadosPedido += "Estado: " + dadosArmazenados.agenda[0].estado;

			dadosPedido += " <br><br> <strong>Dados Produtos</strong> <br><br>";
			dadosArmazenados.produtos.forEach((itemex) => {
				dadosPedido += "Produto Id: " + itemex.itiId + "<br>"
				dadosPedido += "Nome: " + itemex.itiNome + "<br>"
				dadosPedido += "Quantidade: " + itemex.proQtde + "<br><br><hr>"
			});

			let _dadosEmail = {
				nomeDe: dadosArmazenados.agenda[0].nome,
				nomePara: "Induscapas",
				assunto: 'Solicitação de Orçamento Realizado no Site - Nome:  - ' + dadosArmazenados.agenda[0].nome,
				destinatario: this.contato[0].itiCampoExtra1,
				emailResposta: dadosArmazenados.agenda[0].email,
				textoEmail: dadosPedido,
				nomeAnexo: '',
				anexo: '',
				tipoAnexo: ''
			}

			axios.post(`/Process/AdmControleSmtp/Enviamail`, _dadosEmail)
				.then(data => {
					//console.log('data')
					//console.log(data)
					if (data.status == 200) {
						this.$mensagemSucesso("Orçamento enviado!");
						this.$router.push("/carrinhoFinal");
					} else {
						this.$mensagemSucesso(
							data.message || "Houve um problema com envio do email, tente novamente mais tarde."
						);
					}
				});
		},
	},

	created() {
		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/40/topocarrinho/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});

		axios.get('/Process/InsInstitucional/institucional/16/contato/0/x')
			.then(response => {
				this.contato = response.data;
				//console.log('formulario contato')
				//console.log(this.contato)
			})
			.catch(error => {
				console.error(error);
			});

		let dadosArmazenados = localStorage.getItem(this.$DadosCompra);
		if (!dadosArmazenados) {
			dadosArmazenados = this.DadosCompra;
			localStorage.setItem(this.$DadosCompra, JSON.stringify(dadosArmazenados))
			this.$mensagemAviso("Carrinho vazio, escolha produtos e adicione no carrinho.")
			this.$router.push('/')
		}
		else {
			dadosArmazenados = JSON.parse(dadosArmazenados);
			this.DadosCompra = dadosArmazenados;
			if (this.DadosCompra.produtos.length == 0) {
				this.$mensagemAviso("Carrinho vazio, escolha produtos e adicione no carrinho.")
				this.$router.push('/')
			}
			if (this.DadosCompra.agenda !=null) {
			if (this.DadosCompra.agenda.length > 0) {
				this.nome = this.DadosCompra.agenda[0].nome;
				this.telefone = this.DadosCompra.agenda[0].telefone;
				this.email = this.DadosCompra.agenda[0].email;
				this.cnpj = this.DadosCompra.agenda[0].cnpj;
				this.responsavel = this.DadosCompra.agenda[0].responsavel;
				this.siglaEstado = this.DadosCompra.agenda[0].estado;
				this.nomeCidade = this.DadosCompra.agenda[0].cidade;
				this.nomeBairro = this.DadosCompra.agenda[0].bairro;
				this.endereco = this.DadosCompra.agenda[0].endereco;
				this.numeroend = this.DadosCompra.agenda[0].numero;
				this.complemento = this.DadosCompra.agenda[0].complemento;
				this.numCep = this.DadosCompra.agenda[0].cep;
				this.Observacoes = this.DadosCompra.agenda[0].Obs;
				this.showend = true;
			}
			}

		}


	},
}

</script>

<style scoped>
/*=========================================================
	09 -> CHECKOUT PAGE
===========================================================*/

.billing-details {
	margin-bottom: 30px;
}

.shiping-details {
	margin-bottom: 30px;
}

.order-details {
	position: relative;
	padding: 0px 30px 30px;
	border-right: 1px solid #E4E7ED;
	border-left: 1px solid #E4E7ED;
	border-bottom: 1px solid #E4E7ED;
}

.order-details:before {
	content: "";
	position: absolute;
	left: -1px;
	right: -1px;
	top: -15px;
	height: 30px;
	border-top: 1px solid #E4E7ED;
	border-left: 1px solid #E4E7ED;
	border-right: 1px solid #E4E7ED;
}

.order-summary {
	margin: 15px 10px;
}

.order-summary .order-col {
	display: table;
	width: 100%;
}

.order-summary .order-col:after {
	content: "";
	display: block;
	clear: both;
}

.order-summary .order-col>div {
	display: table-cell;
	padding: 10px 10px;
}

.order-summary .order-col>div:first-child {
	width: calc(100% - 150px);
}

.order-summary .order-col>div:last-child {
	width: 150px;
	text-align: right;
}

.order-summary .order-col .order-total {
	font-size: 24px;
	color: #003661;
}

.order-details .payment-method {
	margin: 30px 0px;
}

.order-details .order-submit {
	display: block;
	margin-top: 30px;
}
</style>
